module.exports = __webpack_public_path__ + "static/img/仓库4@2x.4e8e3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/仓库4@2x.png
// module id = nBlS
// module chunks = 1